export const generateTimestampFileName = (baseName: string, extension: string): string => {
  const now = new Date();
  const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
  return `${baseName}_${timestamp}.${extension}`;
};

export function extractErrorMessage(error: unknown): string | undefined {
  if (!error || typeof error !== "object") return undefined;
  const err = error as { status?: number; data?: { messages?: string[] } };
  const messages = err.data?.messages;
  if (Array.isArray(messages) && messages.length > 0) return messages[0];
  return undefined;
}

export function isStoreConnectionError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const err = error as { status?: number };
  return err.status === 503 || err.status === 500;
}
